export default __webpack_public_path__ + "static/media/image-ph-health-alarm-m@3x.cc4703de.webp";